import { Navigate, useParams, useSearchParams } from 'react-router';

export const LearningModuleChatRedirect = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();

  const path = id ? `/learning/modules/${id}` : '/learning';

  const params = new URLSearchParams();
  const forwardedParams = ['conversationId', 'prompt'];
  for (const key of forwardedParams) {
    const value = searchParams.get(key);
    if (value) {
      params.set(key, value);
    }
  }

  const query = params.toString();
  const target = query ? `${path}?${query}` : path;

  return <Navigate to={target} replace />;
};
